import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../CustomTooltip';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Section header for renderModuleTitle: icon + translated title + right separator.
 *
 * @param {React.ElementType} Icon - SVG icon component.
 * @param {string} title - Translation key.
 */
const AssignedSectionTitle = ({ Icon, title }) => {
    const { t } = useTranslation();

    return (
        <div className="d-flex align-items-center justify-content-start mb-3">
            <div><Icon className="mr-8px mb-1" /></div>
            <div className="mr-5 flex-grow-1 minw-0 p-0">
                <CustomTooltip
                    text={t(title)}
                    classes="fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row"
                    showIfTruncated={true}
                />
            </div>
            <div className="vertical-separator-shades-950 h-auto" />
        </div>
    );
};

export default AssignedSectionTitle;
